import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';

const optionSx = (selected) => ({
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '999px',
  minWidth: 72,
  px: 2,
  py: 0.4,
  borderColor: selected ? ColorPalette.blueMain : ColorPalette.border,
  color: selected ? ColorPalette.white : ColorPalette.textDark,
  background: selected ? `linear-gradient(135deg, ${ColorPalette.blueMain} 0%, #4A6BFF 100%)` : ColorPalette.white,
  '&:hover': {
    borderColor: ColorPalette.blueMain,
    background: selected ? `linear-gradient(135deg, #4A6BFF 0%, ${ColorPalette.blueMain} 100%)` : ColorPalette.blueAlpha
  }
});

/**
 * Pergunta "Esta aula ajudou?" depois que a lição foi assistida.
 * @param {Number|null} value - 1 sim, 0 não, null sem resposta
 * @param {Function} onAnswer - recebe true (sim) ou false (não)
 */
const LessonFeedback = ({ value, onAnswer }) => {
  const answered = value === 0 || value === 1;

  return (
    <Box
      sx={{
        mt: 2,
        px: 2,
        py: 1.25,
        borderRadius: '14px',
        backgroundColor: ColorPalette.bgMain,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        flexWrap: 'wrap'
      }}
    >
      <Typography sx={{ fontWeight: 600, color: ColorPalette.textDark, fontSize: '0.95rem' }}>
        {answered ? 'Obrigado pelo retorno.' : 'Esta aula ajudou?'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="outlined" size="small" onClick={() => onAnswer(true)} sx={optionSx(value === 1)}>
          Sim
        </Button>
        <Button variant="outlined" size="small" onClick={() => onAnswer(false)} sx={optionSx(value === 0)}>
          Não
        </Button>
      </Box>
    </Box>
  );
};

export default LessonFeedback;
